// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__fxCNj","content":"modal_content__QHEE3","header":"modal_header__EHUVV","body":"modal_body__MI_Xu"};